import { Props_SnippetTextBlock } from "./TextBlock.props";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetTextBlock = (props: Props_SnippetTextBlock) => {
  const { heading, repeatable_content } = props;
  const classHeadingVisibility: string = heading.visibility.value
    ? `snippet-text-block__heading--${heading.visibility.value}`
    : "";

  return (
    <section className="snippet-text-block" id={heading?.snippetid?.value || ""}>
      <div className="snippet-text-block__container">
        {heading.content && (
          <h2
            className={`snippet-text-block__heading ${classHeadingVisibility}`}
          >
            {heading.content?.value}
          </h2>
        )}
        <div className="snippet-text-block__content-section">
          {repeatable_content.map((item, index) => (
            <div className="snippet-text-block__content-item" key={`content-item-${index}`}>
              {item.subtitle && (
                <h3 className="snippet-text-block__subheading" key={`subtitle-${index}`}>
                  {item.subtitle?.value}
                </h3>
              )}
              <div key={`text-content-${index}`} className="snippet-text-block__text-content">
                {item.content?.value && CompileMarkdown(item.content?.value)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SnippetTextBlock;